var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7922 8.84565H25.726V8.8H13.8126V13.2H21.2935C20.2021 15.7614 17.2694 17.6 13.8126 17.6C9.42644 17.6 5.87029 14.6448 5.87029 11C5.87029 7.35515 9.42644 4.4 13.8126 4.4C15.8372 4.4 17.6791 5.0347 19.0816 6.07145L22.8257 2.9601C20.4616 1.12915 17.2992 0 13.8126 0C6.50236 0 0.575439 4.92525 0.575439 11C0.575439 17.0748 6.50236 22 13.8126 22C21.1228 22 27.0497 17.0748 27.0497 11C27.0497 10.2625 26.9583 9.5425 26.7922 8.84565Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10168 5.88005L6.45074 8.5305C7.62752 6.1094 10.4775 4.4 13.8126 4.4C15.8372 4.4 17.6791 5.0347 19.0816 6.07145L22.8257 2.9601C20.4616 1.12915 17.2992 0 13.8126 0C8.72819 0 4.3189 2.38535 2.10168 5.88005Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 22C17.2317 22 20.3384 20.9127 22.6874 19.1444L18.5905 16.2635C17.2168 17.1317 15.5383 17.6012 13.8125 17.6C10.3696 17.6 7.44615 15.7757 6.34482 13.2297L2.0282 15.9935C4.21894 19.5558 8.66794 22 13.8125 22Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7922 8.8457H25.7259V8.80005H13.8125V13.2H21.2935C20.7714 14.4191 19.831 15.4843 18.5885 16.2641L18.5904 16.263L22.6873 19.1439C22.3974 19.3628 27.0496 16.5 27.0496 11C27.0496 10.2625 26.9583 9.54255 26.7922 8.8457Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b2524d68194cf3cb1ea55c3114218777.svg";
export { ForwardRef as ReactComponent };